import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux'
import {Field, reduxForm, formValueSelector, change} from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { FormButtons, validations, renderers } from '../../components'

let ScheduleReportForm = ({
  handleSubmit,
  pristine,
  reset,
  dispatch,
  submitting,
  rights,
  report_types,
  report_type
}) => {
  const [canSkipDate, setCanSkipDate] = useState()

  useEffect(() => {
    setCanSkipDate(["SERIALIZABLE_INVENTORY_STOCK_REPORT",
    "LOANER_INVENTORY_STOCK_REPORT",
    "REPAIR_INVENTORY_STOCK_REPORT"].includes(report_type))
    if (canSkipDate){
    dispatch(
            change(
              "schedule-report-form",
              'start_date',
              new Date() - 365
            )
          )
   dispatch(
            change(
              "schedule-report-form",
              'end_date',
              new Date()
            )
          )
  }
  }, [canSkipDate,report_type]);


  console.log("can_skip_date",canSkipDate)
  return (
    <ReactBootstrap.Col xs={12}>
      <form onSubmit={handleSubmit}>
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs="12">
            <Field
              component={renderers.renderSelectField}
              as="select"
              name="report_type"
              validate={[validations.required]}
              label="Report Type"
            >
              {report_types &&
                report_types.map((sp) => (
                  <option key={sp.url} value={sp.value}>
                    {sp.value}
                  </option>
                ))}
            </Field>
          </ReactBootstrap.Col>
          <ReactBootstrap.Col>
            <Field
              component={renderers.renderSelectField}
              as="select"
              name="organization"
              label="Ship To"
            >
              {rights &&
                rights.map((opt) => (
                    <option
                      key={opt.organization_code}
                      value={opt.organization}
                    >
                      {opt.organization_code}-{opt.organization_name}
                    </option>
                  ))}
            </Field>
          </ReactBootstrap.Col>
          <ReactBootstrap.Col xs={12}>
            <Field
              name="start_date"
              label="Start Date"
              validate={canSkipDate?[]:[validations.required]}
              hideTimeSelect={true}
              minDate={new Date() - 365}
              component={renderers.renderDatePicker}
            />
            <Field
              name="end_date"
              label="End Date"
               validate={canSkipDate?[]:[validations.required]}
              hideTimeSelect={true}
              minDate={new Date() + 365}
              component={renderers.renderDatePicker}
            />
          </ReactBootstrap.Col>

          <ReactBootstrap.Col md={12} xs={12} lg={12}>
            <FormButtons
              submitting={submitting}
              pristine={pristine}
              reset={reset}
            />
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </form>
    </ReactBootstrap.Col>
  )
}

ScheduleReportForm = reduxForm({
  form: 'schedule-report-form',
})(ScheduleReportForm)

const selector = formValueSelector('schedule-report-form') // <-- same as form name
export default ScheduleReportForm = connect((state) => {
  const report_type = selector(state, 'report_type')
  return {
    report_type,
  }
})(ScheduleReportForm)
